<template>
  <div class="page-table person-list">
    <div class="page-search">
      <a-form :form="searchForm" @submit="handleSearch">
        <a-row>
          <a-col :span="6">
            <a-form-item label="标识地点" :labelCol="{span: 6}" :wrapperCol="{span: 16}">
              <a-input v-decorator="['address']" placeholder="请输入" maxlength="200" />
            </a-form-item>
          </a-col>
          <a-col :span="2" style="line-height: 39px;">
            <a-button style="margin-left: 20px;" type="primary" html-type="submit">查询</a-button>
          </a-col>
          <a-col :span="16" style="text-align:right;line-height: 39px;">
            <a-button style="margin-right:20px;" @click="showModal" type="primary">新增</a-button>
            <a-button style="margin-right:20px;" @click="inputExe" type="primary">批量导入</a-button>
            <a-button @click="exportExe" type="primary">批量下载二维码</a-button>
          </a-col>
        </a-row>
      </a-form>
      <!-- 表格 -->
      <div class="table-operator" style="margin-top: 15px;padding: 0;">
        <standard-table
          :columns="columns"
          showRowSelection
          :dataSource="dataSource"
          :pagination="PAGINATION"
          @change="onChange"
          @rowChange="onRowChange"
        />
      </div>
    </div>
    <!-- 弹框 -->
    <a-modal
      destroyOnClose
      :maskClosable="false"
      title="新增"
      v-model="visible"
      width="700px"
      @ok="handleSubmit"
      @cancel="handleCancel"
    >
      <a-form :form="form">
        <a-row style="padding-left:3.7%">
          <a-col :span="10" style="padding-right: 20px;">
            <a-form-item label="标识地点" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <!-- 校区 -->
              <a-select
                v-decorator="['xqdm',
                  {rules: [{ required: true, message: '请选择校区!' }]}
                ]"
                placeholder="请选择"
                @change="handleSchoolChange"
              >
                <a-select-option
                  v-for="schoolData in schoolData"
                  :key="schoolData.value"
                >{{schoolData.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 宿舍楼 -->
          <a-col v-if="buildData.length > 0" :span="7" style="padding-right: 20px;">
            <a-form-item>
              <a-select
                v-decorator="['lyId',
                  {rules: [{ required: true, message: '请选择宿舍楼!' }]}
                ]"
                placeholder="请选择"
                @change="handleBuildChange"
              >
                <a-select-option
                  v-for="buildData in buildData"
                  :key="buildData.id"
                >{{buildData.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 房间号 -->
          <a-col
            v-if="buildData.length > 0 && roomData.length>0"
            :span="7"
            style="padding-right: 20px;"
          >
            <a-form-item>
              <a-select
                v-decorator="['qyfjh',
                  {rules: [{ required: true, message: '请选择房间号!' }]}
                ]"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="roomData in roomData"
                  :key="roomData.id"
                >{{roomData.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-form-item style="padding-right:20px" label="标识地点" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
          <a-input
            v-decorator="[
              'address',
              {
                rules:[
                  { required: true,message: '请输入标识地点！'},
                ]
              }
            ]"
            placeholder="请输入"
            maxlength="200"
          />
        </a-form-item> -->
      </a-form>
    </a-modal>
    <a-modal
      destroyOnClose
      :maskClosable="false"
      title="查看"
      v-model="visible2"
      width="600px"
      :footer="null"
    >
      <a-form :form="form">
        <a-row style="padding-left:3.7%">
          <a-col :span="10" style="padding-right: 20px;">
            <a-form-item label="报修地点" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
              <!-- 校区 -->
              <a-input disabled v-model="info.xqdm" placeholder="请输入" maxlength="200" />
            </a-form-item>
          </a-col>
          <!-- 宿舍楼 -->
          <a-col :span="7" style="padding-right: 20px;">
            <a-form-item>
              <a-input disabled v-model="info.lyId" placeholder="请输入" maxlength="200" />
            </a-form-item>
          </a-col>
          <!-- 房间号 -->
          <a-col
            :span="7"
            style="padding-right: 20px;"
          >
            <a-form-item>
              <a-input disabled v-model="info.qyfjh" placeholder="请输入" maxlength="200" />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-form-item style="padding-right:20px" label="标识地点" :labelCol="{span: 4}" :wrapperCol="{span:20}">
          <a-input disabled v-model="info.address" placeholder="请输入" maxlength="200" />
        </a-form-item> -->
        <a-form-item style="padding-right:20px" label="二维码" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
          <img style="width:200px;height: 200px;" :src="info.qrcodeUrl"/>
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 弹框 -->
    <a-modal
      destroyOnClose
      :maskClosable="false"
      title="导入目录"
      v-model="visibleupload"
      :footer="null"
    >
      <a-form :form="uploadform">
        <a-form-item label="批量导入" :labelCol="{span: 6}" :wrapperCol="{span: 14}">
          <a-upload
            ref="uploadfile"
            accept="/api/file/upload.do"
            :remove="handleRemove"
            :beforeUpload="beforeUpload"
            :file-list="fileList"
            @change="handleChange"
          >
            <div v-if="file === ''">
              <a-button>
                <a-icon type="upload"/>上传
              </a-button>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item style="padding-left: 120px" :labelCol="{span: 6}" :wrapperCol="{span: 14}">
          <span style="color:#999;">导入模板下载：</span><a @click="downloadTemplet">模板下载>></a>
        </a-form-item>
        <a-form-item label="导入说明" :labelCol="{span: 6}" :wrapperCol="{span: 14}">
          1、上传文件格式仅为excel格式；
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      destroyOnClose
      :maskClosable="false"
      title="批量导入"
      v-model="uploadTempVisiable"
      @ok="handleImport"
      @cancel="modalCancel"
      :confirmLoading="confirmLoading"
    >
      <div class="upnotice title">是否确定导入以下{{ this.tpldataSource.length || 0 }}条数据？</div>
      <div class="upnotice">一经确定，将导入页面，请谨慎操作~</div>
      <div style="max-height: 400px;overflow: auto;">
        <standard-table
          :columns="tplcolumns"
          rowKey="_index"
          :pagination="false"
          :dataSource="tpldataSource"
          />
      </div>
    </a-modal>
    <a-modal
      destroyOnClose
      :maskClosable="false"
      title="导入失败"
      v-model="uploadTempVisiable2"
      :footer="null"
      @cancel="modalCancel"
    >
      <div class="upnotice title">导入失败</div>
      <div class="upnotice">以下{{ this.tpldataSource.length || 0 }}条信息校验失败，请修改后重新导入全部文件</div>
      <div style="max-height: 400px;overflow: auto;">
        <standard-table
          :columns="tplcolumns2"
          rowKey="_index"
          :pagination="false"
          :dataSource="tpldataSource"
          />
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from 'axios'
const env = process.env.NODE_ENV
export default {
  name: 'QueryList',
  data () {
    const tplcolumns = [
      {
        title: '序号',
        align: 'center',
        width: '80px',
        dataIndex: '_index'
      },
      {
        title: '标识地点',
        align: 'center',
        dataIndex: 'key'
      }
    ]
    const tplcolumns2 = [
      {
        title: '序号',
        align: 'center',
        width: '80px',
        dataIndex: '_index'
      },
      {
        title: '标识地点',
        align: 'center',
        dataIndex: 'key'
      },
      {
        title: '失败原因',
        align: 'center',
        dataIndex: 'value'
      }
    ]
    const columns = [
      {
        title: '序号',
        align: 'center',
        dataIndex: '_index'
      },
      {
        title: '标识地点',
        align: 'center',
        dataIndex: 'address',
        customRender: (text, record, index) => {
          return record.xqdm + ' - ' + record.lyId + ' - ' + record.qyfjh
        }
      },
      {
        title: '创建时间',
        align: 'center',
        dataIndex: 'createDate'
      },
      {
        title: '操作',
        align: 'center',
        width: 250,
        customRender: (text, record, index) => {
          return (
            <div class="row-operator">
              <a
                href="javascript:;"
                onClick={() => this.showDetail(record)}
              >
                查看
              </a>
              <a-divider type="vertical" />
              <a
                href="javascript:;"
                onClick={() => this.download(record)}
              >
                下载二维码
              </a>
              <a-divider type="vertical" />
              <a href="javascript:;" onClick={() => this.handleRemovelist(record)}>
                删除
              </a>
            </div>
          )
        }
      }
    ]
    return {
      searchForm: this.$form.createForm(this),
      form: this.$form.createForm(this),
      columns,
      dataSource: [],
      selectedRows: [],
      visible: false,
      visible2: false,
      info: {},
      visibleupload: false,
      uploadform: this.$form.createForm(this),
      file: '',
      tplcolumns,
      tplcolumns2,
      tpldataSource: [],
      uploadsuccess: true,
      uploadTempVisiable: false,
      uploadTempVisiable2: false,
      fileList: [],
      confirmLoading: false,
      // 下拉
      schoolData: [],
      buildData: [],
      roomData: []
    }
  },
  mounted () {
    this.fetchList(this.getFetchParams())
  },
  methods: {
    // 获取默认校区
    schoolList () {
      this.$axios.post('/api/dict/getXqInfo.do').then(res => {
        this.schoolData = res.data.data || []
        this.$nextTick(function () {
          this.form.setFieldsValue({ xqdm: '02' })
          this.handleSchoolChange('02')
        })
      })
      // 获取用户姓名
      this.$axios.post('/api/common/getXmAndSjh.do').then(res => {
        this.username = res.data.data || ''
        this.form.setFieldsValue({ sjh: res.data.sjh })
      })
    },
    // 学校change
    handleSchoolChange (value) {
      this.form.setFieldsValue({ lyId: undefined, qyfjh: undefined })
      this.buildList(value)
    },
    buildList (id) {
      this.$axios.post('/api/bxjl/getBxdd.do', { xqdm: id, activeFlag: '1' }).then(res => {
        this.buildData = res.data.data || []
      })
    },
    // 楼宇change
    handleBuildChange (value) {
      this.form.setFieldsValue({ qyfjh: undefined })
      this.roomList(value)
    },
    roomList (name) {
      this.$axios.post('/api/bxjl/getBxdd.do', { lyId: name, activeFlag: '1' }).then(res => {
        this.roomData = res.data.data || []
      })
    },
    // 获取列表
    fetchList (params) {
      params.currentPageNo = params.pageNum
      this.$axios.post('/api/mark/queryAddressPageAjax.do', params).then(res => {
        this.dataSource = res.rows || []
        // 处理分页情况
        const { pageNum, pageSize } = params
        this.PAGINATION = {
          total: res.total || 0,
          pageNum,
          pageSize
        }
      })
    },
    // 搜索
    handleSearch (e) {
      e.preventDefault()
      this.fetchList(this.getFetchParams({ pageNum: 1 }))
    },
    onRowChange (selectedRows) {
      // console.log(selectedRows)
      this.selectedRows = selectedRows
    },
    // 切换数据
    onChange (changeParams) {
      this.fetchList(this.getFetchParams(changeParams))
    },

    /**
     * 获取请求列表参数
     * @param { Object } customParam 自定义处理
     * @return { Object } 请求列表参数
     */
    getFetchParams (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...this.PAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      return params
    },
    // 显示弹框
    showModal () {
      this.visible = true
      this.schoolList()
    },
    showDetail (record) {
      this.visible2 = true
      this.$axios.post('/api/mark/queryAddressInfoByIdAjax.do', { id: record.id }).then(res => {
        this.info = res.data
      })
    },
    // 下载二维码
    download (record) {
      // record.preventDefault()
      let url = env === 'production' ? '/mark/downloadQrcodeZipAjax.do' : '/api/mark/downloadQrcodeZipAjax.do'
      this.epxportway(url, { allId: record.id })
    },
    // 批量导入
    inputExe () {
      this.file = ''
      this.fileList = []
      this.visibleupload = true
    },
    // 下载模板
    downloadTemplet (e) {
      e.preventDefault()
      let url = env === 'production' ? '/mark/downloadAddressTemp.do' : '/api/mark/downloadAddressTemp.do'
      this.epxportway(url, {})
    },
    // 导出
    exportExe (e) {
      if (this.selectedRows.length === 0) {
        this.$message.warn('请选择要')
        return false
      }
      e.preventDefault()
      let url = env === 'production' ? '/mark/downloadQrcodeZipAjax.do' : '/api/mark/downloadQrcodeZipAjax.do'
      const ids = this.selectedRows.map(item => {
        return item.id
      })
      this.epxportway(url, { allId: ids.join(',') })
    },
    // 导出方法
    epxportway (url, data) {
      if (url && data) {
        var form = window.$('<form></form>')
        form.attr('action', url)
        form.attr('method', 'post')
        for (var item in data) {
          var input = window.$('<input type="text" />')
          input.attr('name', item)
          input.attr('value', data[item])
          form.append(input)
        }
        form
          .appendTo('body')
          .submit()
          .remove()
      }
    },
    // 新增、编辑
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 接口请求
          this.submitAjax(values)
        }
      })
    },
    handleCancel () {
      this.roomData = []
    },
    // 新增、编辑请求
    submitAjax (params) {
      this.$axios.post('/api/mark/addAddress.do', params).then(res => {
        this.$message.success(`${params.id ? ' 编辑' : '新增'}成功！`)
        this.visible = false

        this.fetchList(this.getFetchParams({ pageNum: 1 }))
      })
    },
    // 删除
    handleRemovelist (record) {
      this.$confirm({
        title: '提示',
        content: '确定删除该条数据？',
        okType: 'danger',
        onOk: () => {
          // 删除请求
          this.removeAjax({ id: record.id })
        }
      })
    },
    // 删除请求
    removeAjax (params) {
      this.$axios.post('/api/mark/deleteAddress.do', params).then(res => {
        this.$message.success(`删除成功！`)
        this.fetchList(this.getFetchParams({ isRemove: true }))
      })
    },
    getParams (custParam) {
      let params = {
        ...this.searchForm.getFieldsValue(),
        ...custParam
      }
      return params
    },
    beforeUpload (file) {
      this.file = file
      this.fileList = [file]
      return false
    },
    // 文件上传
    handleChange ({ file }) {
      this.file = file
      if (this.file === '') {
        return
      }

      const _this = this
      const formData = new FormData()
      formData.append('multipartFile', this.file)
      // 打包URL配置
      let url = '/api/mark/importExcelAddressAjax.do'
      if (process.env.NODE_ENV === 'production') {
        url = url.replace('/api', '')
      }
      axios.request({
        url: url,
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.data.data.isSuccess === '1') {
          this.uploadTempVisiable = true
        } else {
          this.uploadTempVisiable2 = true
        }
        _this.tpldataSource = res.data.data.datas
      }).catch(err => {
        console.log(err)
      })
    },
    // 移除文件
    handleRemove () {
      this.file = ''
      this.fileList = []
    },
    // 上传请求
    handleImport () {
      const arr = this.tpldataSource.map(item => {
        return item.value
      })
      const params = {
        address: arr.join(',')
      }
      this.confirmLoading = true
      this.$axios.post('/api/mark/addAllAddressAjax.do', params).then(res => {
        this.confirmLoading = false
        this.$message.success(`批量导入成功！`)
        this.fetchList(this.getFetchParams({ pageNum: 1 }))
        this.uploadTempVisiable = false
        this.visibleupload = false
      })
    },
    modalCancel () {
      this.file = ''
      this.fileList = []
    }
  }
}
</script>
<style lang="less">
.person-list {
  .ant-radio-group-outline,
  .ant-form-item-control-wrapper {
    line-height: 40px;
  }
}
.ant-layout-content .person-list .page-search {
  border-bottom: none;
}
.upnotice {
  text-align: center;
  font-size: 14px;
  color: #666;
  margin: 6px 0;
}
.upnotice.title {
  text-indent: 20px;
  font-size: 24px;
  color:#333;
}
</style>
